import React, { PureComponent as Component } from 'react';
import Base from "./compose";
import { getStyle } from "./optionCallback";
import filterObject from "@gqlapp/base/utils/filterObject";

class Styles extends Component {
	
	static propTypes = {
	
	}
	
	static defaultProps = {}
	
	render() {
		
		// @ts-ignore
		let style = this.props?.style, QrcodeStyles = this.props?.QrcodeStyles;
		// @ts-ignore
		let children = this.props?.children, opacity = this.props?.opacity;
		
		let propKeys: string[] = 'children, params, frameProps'.split(',');
		propKeys = propKeys.map(value => `${value}`.trim());
		
		let dataStyle: any, _props = {...this.props};
		
		let props = filterObject(_props, function ({}, key: any) {
			return propKeys.includes(key)
		})
		
		let render = (<svg
			xmlns="http://www.w3.org/2000/svg"
			{...{ opacity, width: 1000, height: 1000}}
			{...{ viewBox: '0 0 1000 1000'}}>
			{children}
		</svg>)
		
		if ((dataStyle = getStyle(QrcodeStyles, style))) {
			Object.assign(props, { children: render });
			return func(dataStyle?.callback)(props)
		}
		
		return render;
	}
	
}


// @ts-ignore
export default Base(Styles);
